// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 8912 ? "form-validator" : chunkId) + ".chunk.min.js";
};